// extracted by mini-css-extract-plugin
export var discard = "_3w-3";
export var muiTooltipTooltip = "_3w-5";
export var notificationBar = "_3w-2";
export var saveButtonHoverSlotWrapper = "_3w-4";
export var show = "_3w-1";
export var spacer = "_3w-0";